import InscriptionEquipeColos from './InscriptionEquipeColos';

export default InscriptionEquipeColos;
